import { SortingState } from '@tanstack/react-table';
import { useMutation } from 'react-query';

import { extractResourceTableCardToCsv as mutationFn } from 'api/endPoints/extractResourceTableCardToCsv';
import { IVersion } from 'api/queries/getProjectVersionsList.query';

import { Range } from 'components/common/GlobalFilterComponent/components/RangeFilter/rangeFilter';
import { QuickAnswerFilter } from 'components/common/GlobalFilterComponent/components/quickAnswerFilter/quickAnswerFilter';
import { Pagination } from 'components/common/pagination/customPagination';

import { IFilter } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { Aggregation } from 'components/widgets/ResourcesAnalysisChart/ResourcesAnalysisChart.consts';

export const useMutationCsvExportResourceTable = () => {
    return useMutation<unknown, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryParams {
    metaDataId: IVersion['id'] | null;
    comparedMetaDataId: IVersion['id'] | null;
    range: Range | undefined;
    filter: {
        filters: IFilter[];
    };
    sortingRequestList: SortingState;
    paging: Pagination;
    barId: string | null;
    aggregation: Aggregation;
    quickAnswerFilter?: QuickAnswerFilter;
    fileName?: string;
}
